import React, { useCallback } from 'react';

import { Text, TouchableOpacity } from 'react-native';

import { useSelector } from 'react-redux';

import CheckmarkIcon from 'assets/images/svgs/ico_checkmark.svg';

import { selectLayoutConfig } from 'store/config/selectors';

import { DateItem } from 'screens/Epg/hooks/useDatePicker';

import styles from './styles';

type Props = {
    item: DateItem;
    handleClose: () => void;
    onPressDatePickerItem: (item: DateItem) => void;
    testID?: string;
};

const BottomSheetDatePickerRowItem = ({
    item,
    handleClose,
    onPressDatePickerItem,
    testID,
}: Props) => {
    const { primary } = useSelector(selectLayoutConfig);

    const onPress = useCallback(() => {
        onPressDatePickerItem(item);

        handleClose();
    }, [onPressDatePickerItem, item, handleClose]);

    return (
        <TouchableOpacity
            style={[
                styles.container,
                item.isSelected && {
                    backgroundColor: primary,
                },
            ]}
            activeOpacity={0.5}
            onPress={onPress}
            testID={testID}
            accessibilityLabel={item.label}
            aria-selected={item.isSelected}
        >
            <Text
                style={[styles.title, item.isSelected && styles.selectedTitle]}
            >
                {item.label}
            </Text>
            {item.isSelected && <CheckmarkIcon style={styles.checkMark} />}
        </TouchableOpacity>
    );
};

export default BottomSheetDatePickerRowItem;
